import React from 'react';
import './package.css'; // Import CSS file for styling
import TranslateText from 'translation/TranslateText';
function SweepHeader() {

  
  return (
    <div className="page-header-container">
      <div
        className="page-header section-dark"
        style={{
          backgroundImage: `url(${require("assets/img/BadCreditSweep.png")})`,
          backgroundSize: "cover",
        }}
        
      >
        <div className="centered">
          <h1 className='age inq'><TranslateText text= "Complete Credit Sweep Services" /></h1>
        </div>
      </div>
      
    </div>
  );
}

export default SweepHeader;